<template>
  <div class="history">

      <div class="day_history" v-for="(item,index) in browse" :key="index">

        <p style="padding:0 .25rem .25rem">{{item[0].browse_ymd_str}}</p>
        <ul style="overflow-x:auto;display: flex;">
          <li v-for="(val,item_index) in item" :key="item_index" @click="href(val.service_id)">
            <img :src="val.service_img" alt="">
            <p>{{val.service_title}}</p>
          </li>
        </ul>
        
      </div>

  </div>
</template>

<script>

export default {
  name: "history",
  components: { },
  data() {
    return {
      browse:[]
    }
  },
  created() {
    this.axios({
        url: this.api.member.get_browse, 
        data: {}
      }).then(res => {
        if (res.error === 0) {
          this.browse = res.item;

        }
      });
  },
  methods: {
    href(service_id){
      this.$router.push({ path: '/itemDetails', query: { service_id: service_id}});
    }
  }
};
</script>
<style scoped>
.day_history{
  padding:.75rem .4rem;
}
.day_history p{
  font-size:.6rem;
  color:#212020;
}
.day_history li{
  width:30%;
  margin:0 1.5%;
  background-color:white;
  float:left;
  flex-shrink: 0;
}
.day_history li p{
  color:#4B4D4D;
  padding:.3rem;
}
</style>



// WEBPACK FOOTER //
// src/views/center/history.vue